<template>
  <div>
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area inner"
    >
      <preview-text-count
        :name="columnName + 'キャッチ'"
        :count-target="companyTopic.caption"
      />
      <preview-text-count
        :name="columnName + '本文'"
        :count-target="companyTopic.text"
      />
      <preview-text-count
        :name="columnName + 'キャプション'"
        :count-target="companyTopic.photo.caption"
      />
    </div>
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      class="pega-comment-bar-inner"
      v-on="$listeners"
    />
    <div
      :class="index === '1' ? 'topics_1st' : 'topics_2nd'"
      class="clearfix"
      data-test="topic-class"
    >
      <div>
        <h5
          :id="targetIdMap.message.title + '-' + index"
          data-test="catch"
        >
          {{ companyTopic.caption.value }}
        </h5>
        <p
          :id="targetIdMap.message.body + '-' + index"
          class="pega-pre-wrap"
          data-test="body"
          v-text="companyTopic.text.value"
        />
      </div>
      <figure class="topic_figure">
        <img
          :id="targetIdMap.message.photo + '-' + index"
          class="lazy"
          data-test="photo"
          :alt="companyTopic.caption.value"
          :src="userImageUrl + companyTopic.photo.id"
          @load="$emit('onLoadImage')"
          @error="$emit('onLoadImage')"
        >
        <figcaption
          :id="targetIdMap.message.photoCaption + '-' + index"
          class="caption pega-pre-wrap"
          data-test="photo-caption"
          v-text="companyTopic.photo.caption.value"
        />
      </figure>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    index: {
      type: String,
      required: true
    },
    companyTopic: {
      type: Object,
      required: true
    },
    columnName: {
      type: String,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
